import { Link } from "react-router-dom";
import ProductItemBase from "components/ProductItemBase";
import replicaItems from "assets/replica-items";
import { routes } from "config";
import styled from "styled-components";

const ReplicaItemsGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, 18%);
  justify-content: center;
  gap: 12px;
  place-items: center;

  ${(props) => props.theme.breakpoints.L} {
    grid-template-columns: repeat(auto-fit, max(225px, 23%));
  }
  ${(props) => props.theme.breakpoints.M} {
    grid-template-columns: repeat(auto-fit, 30%);
  }
  ${(props) => props.theme.breakpoints.SM} {
    grid-template-columns: repeat(auto-fit, 30%);
  }
  ${(props) => props.theme.breakpoints.S} {
    grid-template-columns: repeat(auto-fit, max(180px, 45%));
  }
  ${(props) => props.theme.breakpoints.XXS} {
    grid-template-columns: repeat(auto-fit, 50%);
  }
`;

const ReplicaItemList = (props?: { renderItems?: () => React.ReactNode }) => {
  const getDisplayedItems = () => {
    return replicaItems;
  };

  return (
    <ReplicaItemsGrid>
      {props?.renderItems
        ? props.renderItems()
        : getDisplayedItems().map((item, i) => (
            <Link
              key={i}
              to={`/${routes.replicaMiscDetail.slug.replace(":id", item.id)}`}
            >
              <ProductItemBase
                product={
                  {
                    ...item,
                  } as any
                }
              />
            </Link>
          ))}
    </ReplicaItemsGrid>
  );
};

export default ReplicaItemList;
